const YellowSubmarine = [
	'[Verse 1]',
	'In the town where I was born',
	'Lived a man who sailed to sea',
	'And he told us of his life',
	'In the land of submarines',
	'',
	'So we sailed up to the sun',
	'Till we found the sea of green',
	'And we lived beneath the waves',
	'In our yellow submarine',
	'',
	'[Chorus]',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine',
	'',
	'[Verse 2]',
	'And our friends are all on board',
	'Many more of them live next door',
	'And the band begins to play',
	'',
	'[Chorus]',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine',
	'',
	'[Verse 3]',
	'As we live a life of ease',
	'Everyone of us has all we need',
	'Sky of blue and sea of green',
	'In our yellow submarine',
	'',
	'[Chorus]',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine',
	'We all live in a yellow submarine',
	'Yellow submarine, yellow submarine 2x',
];

export default YellowSubmarine;
